import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';

type State = {
	enabled: boolean;
	// This is used to determine if the Streaming Advisory should be rendered on the client.
	enableAdvisory: boolean;
};

const DEFAULT_STATE: State = {
	enabled: false,
	enableAdvisory: false,
};

let state = Object.freeze(DEFAULT_STATE);

autoBeforeEachTest(() => {
	state = DEFAULT_STATE;
});

export const enableStreaming = (): void => {
	if (state.enabled) {
		throw new Error('Enable Streaming: Streaming already enabled');
	}

	state = { ...state, enabled: true };
};

export const enableStreamingAdvisory = (): void => {
	if (state.enableAdvisory) {
		throw new Error('Enable Streaming Advisory: Streaming Advisory already enabled');
	}

	state = { ...state, enableAdvisory: true };
};

export const isStreamingEnabled = (): boolean => {
	return state.enabled;
};

export const isStreamingAdvisoryEnabled = (): boolean => {
	return state.enableAdvisory;
};
